import $ from '../../../../../FrontendBundle/Resources/js/jquery';
import SetFontSizeCommand from '../command/setFontSizeCommand';
import TextItem from '../item/textItem';
import DropdownField from './dropdownField';

/**
 * @class FontSizeField
 */
export default class FontSizeField extends DropdownField {
    type = 'fontSize';
    supports = null;

    /**
     * Register click event on dropdown.
     *
     * @param {jQuery} dropdown
     */
    registerEventsForDropdown(dropdown) {
        dropdown.on('click', 'li a', (...args) => this.onChangeFontSize(...args));
    }

    /**
     * @param {Event} event
     */
    onChangeFontSize(event) {
        const target = $(event.target);
        const selection = this.getSelection();
        const canvas = this.editor.getCanvas();
        const history = canvas.getHistory();

        const command = new SetFontSizeCommand(
            selection,
            target.data('item'),
        );

        history.addAndExecuteCommand(command);

        event.preventDefault();
    }

    /**
     * Update text with item value.
     */
    updateText() {
        const selection = this.getSelection();
        const fontSizeCount = {};
        let maxSize = 0;

        selection.each((item) => {
            const fontSize = item.get('fontSize');

            if (!fontSizeCount[fontSize]) {
                fontSizeCount[fontSize] = 0;
            }

            fontSizeCount[fontSize] += 1;

            if (!maxSize || fontSizeCount[fontSize] > fontSizeCount[maxSize]) {
                maxSize = fontSize;
            }
        });

        if (Object.keys(fontSizeCount).length > 1) {
            maxSize = `<i>${maxSize}, ...</i>`;
        }

        this.button.children('.text').html(maxSize);
    }

    /**
     * Update text with item value.
     *
     * @param {ItemInterface} item
     */
    updateOptions(item) {
        const availableSizes = [...item.getParentItem().get('availableLabelSizes')];
        const currentSize = item.get('fontSize');

        if (!availableSizes.includes(currentSize)) {
            availableSizes.push(currentSize);
            availableSizes.sort((sizeA, sizeB) => sizeA - sizeB);
        }

        const options = availableSizes.map(size => ({
            key: size,
            value: size,
            active: size === currentSize,
        }));

        this.setOptions(options);
    }

    /**
     * Update item with field value.
     */
    updateItem() {
    }

    /**
     * Check if field is supportet by item.
     *
     * @return {boolean}
     */
    isSupported() {
        const selection = this.getSelection();
        let isSupported = true;

        if (selection.length < 1) {
            return false;
        }

        selection.each((item) => {
            isSupported = isSupported && item instanceof TextItem;
        });

        if (!isSupported) {
            return false;
        }

        if (selection.first().getParentItem().get('availableLabelSizes').length <= 1) {
            return false;
        }

        return true;
    }

    getSelection() {
        return this.editor.getCanvas().getSelection();
    }
}
